const CONTACT_INFO = {
  phone: '+4 (033) 640-1269',
  email: 'contact@nonlinear.ro',
};

export default CONTACT_INFO;
